/**
 * @desc: 支付交易/当前交易
 * @created: 2020/6/9
 * @author: Colorfule
 * @version: v1.0
 */

import request from '@/plugins/http'

export const getListData = params => {
  return request.get('/payment/list/current', params)
}

export const getBillDetails = params => {
  return request.get('/payment/details', params)
}
